import { RAISE_API_V1_URL } from "constants/endpoints";
import { get } from "services/api";

export const getRecommendationsByLegacyBrandId = async (legacyBrandId) => {
  const response = await get(`${RAISE_API_V1_URL}/recommendations`, {
    params: {
      brand_uuid: legacyBrandId,
      limit: 6
    }
  });
  return response.data.data;
};
